// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"RR","selections":"SR","pillsDesktopSearchMenu":"TR"};